export default __webpack_public_path__ + "static/media/profilepage-referralCopy.bd8e6375.svg";